import React from 'react';
import {bool, func, node, string} from 'prop-types';

import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import classes from './ConfirmButton.module.css';

const ConfirmButton = ({
    children,
    className,
    confirm,
    disabled,
    hidden,
    isLoading,
    label,
    onClick,
    type,
    ...props
}) => {
    if (hidden) {
        return null;
    }
    let content = children || label;

    if (confirm) {
        onClick = confirm;
    }

    if (isLoading) {
        content = (
            <React.Fragment>
                <CircularProgress
                    className={clsx(
                        classes.progress,
                        {
                            [classes.disabledProgress]: disabled
                        }
                    )}
                    size={25}
                />
                <span>{content}</span>
            </React.Fragment>
        );
    }

    return (
        <Button
            className={`${classes.confirm} ${className}`}
            data-test-id="confirm"
            disabled={disabled || isLoading}
            onClick={onClick}
            type={type}
            variant="contained"
            {...props}
        >
            {content}
        </Button>
    );
};

ConfirmButton.defaultProps = {
    className: '',
    disabled:  false,
    hidden:    false,
    isLoading: false,
    onClick:   () => {},
    type:      'submit'
};

ConfirmButton.propTypes = {
    children:  node,
    className: string,
    disabled:  bool,
    hidden:    bool,
    isLoading: bool,
    label:     string,
    onClick:   func,
    type:      string
};

export default ConfirmButton;
